import * as React from 'react';
import classNames from 'classnames';
import './Card.scss';
import SpinnerV2 from '../SpinnerV2';
import { ReactComponent as IconArrowLong } from '../../assets/icons/arrow_right.svg';
import { Button } from '@repo/apg-ui';

export interface Props {
  color?: string;
  text?: string;
  relative?: boolean;
  button?: boolean;
  loadMore?: boolean;
  cardRow?: boolean;
  to?: any;
  hideArrow?: boolean;
  title?: string;
  icon?: any;
  openLinkInNewTab?: boolean;
  buttonText?: any;
  loading?: boolean;
}

const Card: React.FC<Props> = ({
  to,
  title,
  text,
  icon,
  cardRow,
  buttonText,
  hideArrow = false,
  openLinkInNewTab = false,
  loading = false,
}) => {
  const content = (
    <div
      className={classNames(cardRow ? 'card-row custom-card d-flex' : 'custom-card', {
        'custom-card--loading': loading,
      })}
      aria-busy={loading || undefined}
    >
      <div className='icon'>{icon ? icon : <i className='custom-card-icon' />}</div>

      <div className={cardRow ? 'custom-card-text-content d-flex' : 'custom-card-text-content'}>
        <div className='custom-card-title'>{title}</div>
        <div className='custom-card-text'>
          {text}
          {buttonText ? <Button className='reference-button'>{buttonText}</Button> : null}
          {loading ? <SpinnerV2 relative inText /> : hideArrow ? null : <IconArrowLong />}
        </div>
      </div>
    </div>
  );

  // No href while loading, so the tile can't be clicked or opened
  return loading ? (
    <div>{content}</div>
  ) : (
    <a href={to} target={openLinkInNewTab ? '_blank' : '_self'} rel='noreferrer'>
      {content}
    </a>
  );
};

export default Card;
